// extracted by mini-css-extract-plugin
export var errorIcon = "_le-1";
export var nameLogo = "_le-0";